module.exports = __webpack_public_path__ + "static/img/img-features-feature-2-game-5@3x.91faa6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/img-features-feature-2-game-5@3x.png
// module id = z9X1
// module chunks = 18